import { useContext } from 'react';

import { BoothContext } from '../contexts/booth-context';

export function useBooth() {
  const context = useContext(BoothContext);
  if (!context) {
    throw new Error('useBooth must be used within a BoothProvider');
  }
  return context;
}
